
        import 'Summary.9e27640.css-module'
        export default {"Summary":"Summary_Summary_9e27640","WhiteSection":"WhiteSection_Summary_9e27640","Heading":"Heading_Summary_9e27640","DetailsContainer":"DetailsContainer_Summary_9e27640","StartDate":"StartDate_Summary_9e27640","PlanConfig":"PlanConfig_Summary_9e27640"}
    